// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"844":"43f2e88c","913":"5937615f"}[chunkId] + ".chunk.css";
};